import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tally = defineConnector({
  identifier: "tally",
  name: "Tally",
  tagLine: "Online form builder",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.tally\\.so/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Tally API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your [Tally](https://tally.so/) workspace, go to **Settings > Integrations > API** and generate a new API key. You'll need a Tally Pro plan for API access.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Tally account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "tly-84m**************************56Y",
          helperText: "Your Tally API key.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.tally.so/forms?limit=1",
  },
});
